import {AppProps} from "../App";
import BrauBevLogo from "../components/BrauBev/logo/BrauBevLogo";
import {PdfDataService} from "../services/PdfData.service";
import React from "react";
import BillResult from "../components/billResult/BillResult";
import BillEntry, {BillEntryProps} from "../components/billEntry/BillEntry";

const AreaBrauBevView = (props: AppProps) => {
    function renderBillEntries(billEntries: BillEntryProps[], style?: any, additionalDisclaimer?: string): any {
        let elem: any[] = [];
        for(let entry of billEntries) {
            if(additionalDisclaimer)
                entry.additionalDisclaimer = props.billData.areaCostDisclaimer;
            elem.push(<BillEntry {...entry} style={style} />)
        }
        return elem;
    }

    return (
        <div className="Braubev-Pdf Area">
            <div className="Content">
                <BrauBevLogo isSmall={false} date={props.date} provider={"BrauBeviale.com"}/>
                <div className="Sub-Header" style={{marginTop: "3em", marginBottom: "1em"}}>
                    <h2>{props.billData.labelBoothArea + " " + PdfDataService.getDateString("de-DE")}</h2>
                </div>
                <div className="CostHeader">{props.boothHeader.toUpperCase()}</div>
                {renderBillEntries([props.boothEntry], {marginBottom: "40px"}, props.billData.areaCostDisclaimer)}
                <div className="CostHeader">{props.billEntryHeader}</div>
                {renderBillEntries(props.billEntries)}
                <BillResult {...props.billResult}/>
            </div>
            <div className="BillDisclaimerWrapper">
                <div className="BillDisclaimer">
                    {props.disclaimer}
                </div>
            </div>
        </div>
    )
}

export default AreaBrauBevView;